import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import FlightsConverter from '../converter/FlightsConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default { getPassengers: getPassengers };

function getPassengers (reservationId) {
  reservationId = reservationId || 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.getPassengers&timestamp=${currentMillis}&reservationid=${reservationId}`;

  return fetch(url, Request.getBase())
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }
          return {
            status: status,
            data: FlightsConverter.flightsWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}

// function getPassengers () {
//   return new Promise(resolve =>
//     resolve({
//       status: 0,
//       data: PassengersConverter.passengersWireToInt({
//         contacts: {
//           contact: [
//             {
//               _contact_objectid: '4646',
//               _fname: 'John',
//               _lname: 'Doe',
//               _relationship: 'Self',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_editable: '0',
//             },
//             {
//               _contact_objectid: '11625',
//               _fname: 'Tom',
//               _lname: 'Arrow',
//               _relationship: 'Spouse',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_editable: '1',
//             },
//             {
//               _contact_objectid: '11626',
//               _fname: 'Bill',
//               _lname: 'Gates',
//               _relationship: 'Staff',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_editable: '1',
//             },
//             {
//               _contact_objectid: '11627',
//               _fname: 'Milan',
//               _lname: 'Rakos',
//               _relationship: 'Accompanied Guest',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_editable: '1',
//             },
//             {
//               _contact_objectid: '11628',
//               _fname: 'Baby',
//               _lname: 'Boy',
//               _relationship: 'Child',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_infant: '1',
//               _is_editable: '1',
//             },
//             {
//               _contact_objectid: '11629',
//               _fname: 'baby',
//               _lname: 'girl',
//               _relationship: 'Child',
//               _age: '33',
//               _agestatus: 'Adult',
//               _is_infant: '1',
//               _is_editable: '1',
//             },
//           ],
//         },
//       }),
//     })
//   );
// }



// WEBPACK FOOTER //
// ./src/remoting/PassengersRemoting.js